import {useMemo} from "react";

import {compact} from "@pg-mono/nodash";

import {POI_DISTANCE_DEFAULT_VALUE_IN_METERS} from "../constants/pois_defaults";
import {IPoi} from "../types/IPoi";
import {PoiType, TransportPoiType} from "../types/PoiType";
import {getPoiPluralizeLabel} from "../utils/poi_type_utils";

interface IHook {
    educationPois: IPoi[];
    entertainmentPois: IPoi[];
    foodPois: IPoi[];
    healthPois: IPoi[];
    shopPois: IPoi[];
    sportPois: IPoi[];
    pois: Record<PoiType, IPoi[]>;
    poisCountLabels: string[];
}

// Those PoiTypes are parsed separately
const excludedPoiTypes = [PoiType.TRANSPORT];

export const usePois = (
    poisFromApi: Record<PoiType, IPoi[] | Record<TransportPoiType, IPoi[]>>,
    distanceFromPoint = POI_DISTANCE_DEFAULT_VALUE_IN_METERS
): IHook => {
    return useMemo(() => {
        const poiKeys = (Object.keys(poisFromApi) as PoiType[]).filter((key) => !excludedPoiTypes.includes(key));

        const poisWithExcludedPois = poiKeys.reduce(
            (acc, key) => {
                acc[key] = poisFromApi[key] as IPoi[];
                return acc;
            },
            {} as Record<PoiType, IPoi[]>
        );

        const poisInDistanceRange = poiKeys.reduce(
            (acc, key) => {
                return {
                    ...acc,
                    [key]: poisWithExcludedPois[key].filter(({distance}) => distance <= distanceFromPoint)
                };
            },
            {} as Record<PoiType, IPoi[]>
        );

        const poisCountLabels = compact(
            poiKeys.reduce((acc, key) => {
                const poiTypeCount = poisInDistanceRange[key].length;
                return poiTypeCount ? acc.concat(getPoiPluralizeLabel(key, poiTypeCount)) : acc;
            }, [] as string[])
        );

        return {
            educationPois: poisInDistanceRange.education || [],
            entertainmentPois: poisInDistanceRange.entertainment || [],
            foodPois: poisInDistanceRange.food || [],
            healthPois: poisInDistanceRange.health || [],
            shopPois: poisInDistanceRange.shops || [],
            sportPois: poisInDistanceRange.sport || [],
            pois: poisWithExcludedPois,
            poisCountLabels
        };
    }, [poisFromApi, distanceFromPoint]);
};
import {useMemo} from "react";

import {compact} from "@pg-mono/nodash";

import {POI_DISTANCE_DEFAULT_VALUE_IN_METERS} from "../constants/pois_defaults";
import {IPoi} from "../types/IPoi";
import {PoiType, TransportPoiType} from "../types/PoiType";
import {getPoiPluralizeLabel} from "../utils/poi_type_utils";

interface IHook {
    educationPois: IPoi[];
    entertainmentPois: IPoi[];
    foodPois: IPoi[];
    healthPois: IPoi[];
    shopPois: IPoi[];
    sportPois: IPoi[];
    pois: Record<PoiType, IPoi[]>;
    poisCountLabels: string[];
}

// Those PoiTypes are parsed separately
const excludedPoiTypes = [PoiType.TRANSPORT];

export const usePois = (
    poisFromApi: Record<PoiType, IPoi[] | Record<TransportPoiType, IPoi[]>>,
    distanceFromPoint = POI_DISTANCE_DEFAULT_VALUE_IN_METERS
): IHook => {
    return useMemo(() => {
        const poiKeys = (Object.keys(poisFromApi) as PoiType[]).filter((key) => !excludedPoiTypes.includes(key));

        const poisWithExcludedPois = poiKeys.reduce(
            (acc, key) => {
                acc[key] = poisFromApi[key] as IPoi[];
                return acc;
            },
            {} as Record<PoiType, IPoi[]>
        );

        const poisInDistanceRange = poiKeys.reduce(
            (acc, key) => {
                return {
                    ...acc,
                    [key]: poisWithExcludedPois[key].filter(({distance}) => distance <= distanceFromPoint)
                };
            },
            {} as Record<PoiType, IPoi[]>
        );

        const poisCountLabels = compact(
            poiKeys.reduce((acc, key) => {
                const poiTypeCount = poisInDistanceRange[key].length;
                return poiTypeCount ? acc.concat(getPoiPluralizeLabel(key, poiTypeCount)) : acc;
            }, [] as string[])
        );

        return {
            educationPois: poisInDistanceRange.education || [],
            entertainmentPois: poisInDistanceRange.entertainment || [],
            foodPois: poisInDistanceRange.food || [],
            healthPois: poisInDistanceRange.health || [],
            shopPois: poisInDistanceRange.shops || [],
            sportPois: poisInDistanceRange.sport || [],
            pois: poisWithExcludedPois,
            poisCountLabels
        };
    }, [poisFromApi, distanceFromPoint]);
};
